import fetch from './fetch'


export const GetMenuUseCaseInfo =(data)=>{
	return fetch('/api/UseCase/GetMenuUseCaseInfo',data,'POST')
}
//登录接口
export const login = (data) => {
	return fetch('/api/User/UserLogin', data, 'POST')
}
//获取菜单权限数据
export const getMenuInfo = (data) => {
	return fetch('/api/Menu/GetMenuInfo', data, 'GET')
}
//获取菜单权限数据
export const GetMenuList = (data) => {
	return fetch('/api/Menu/GetNewMenuInfo', data, 'POST')
}

//营业执照列表
export const GetBusinessLicenseList = (data) => {
	return fetch('/api/BusinessLicense/GetBusinessLicenseList', data, 'POST')
}
export const DeleteBusinessLicense = (data) => {
	return fetch('/api/BusinessLicense/DeleteBusinessLicense', data, 'POST')
}
export const EditBusinessLicense = (data) => {
	return fetch('/api/BusinessLicense/EditBusinessLicense', data, 'POST')
}
export const AddBusinessLicense = (data) => {
	return fetch('/api/BusinessLicense/AddBusinessLicense', data, 'POST')
}
//资质证书
export const GetQualificationsCertificateList = (data) => {
	return fetch('/api/QualificationsCertificate/GetQualificationsCertificateList', data, 'POST')
}
export const DeleteQualificationsCertificate = (data) => {
	return fetch('/api/QualificationsCertificate/DeleteQualificationsCertificate', data, 'POST')
}
export const EditQualificationsCertificate = (data) => {
	return fetch('/api/QualificationsCertificate/EditQualificationsCertificate', data, 'POST')
}
export const AddQualificationsCertificate = (data) => {
	return fetch('/api/QualificationsCertificate/AddQualificationsCertificate', data, 'POST')
}
//安全许可证
export const GetSafetyProductionLicenseList = (data) => {
	return fetch('/api/SafetyProductionLicense/GetSafetyProductionLicenseList', data, 'POST')
}
export const DeleteSafetyProductionLicense = (data) => {
	return fetch('/api/SafetyProductionLicense/DeleteSafetyProductionLicense', data, 'POST')
}
export const EditSafetyProductionLicense = (data) => {
	return fetch('/api/SafetyProductionLicense/EditSafetyProductionLicense', data, 'POST')
}
export const AddSafetyProductionLicense = (data) => {
	return fetch('/api/SafetyProductionLicense/AddSafetyProductionLicense', data, 'POST')
}
//银行账户
export const GetBankAccountList = (data) => {
	return fetch('/api/BankAccount/GetBankAccountList', data, 'POST')
}
export const DeleteBankAccount = (data) => {
	return fetch('/api/BankAccount/DeleteBankAccount', data, 'POST')
}
export const EditBankAccount = (data) => {
	return fetch('/api/BankAccount/EditBankAccount', data, 'POST')
}
export const AddBankAccount = (data) => {
	return fetch('/api/BankAccount/AddBankAccount', data, 'POST')
}
//自定义企业证书
export const GetComCustomizeCertificateList = (data) => {
	return fetch('/api/CustomizeCertificate/GetComCustomizeCertificateList', data, 'POST')
}
export const DeleteComCustomizeCertificate = (data) => {
	return fetch('/api/CustomizeCertificate/DeleteComCustomizeCertificate', data, 'POST')
}
export const EditComCustomizeCertificate = (data) => {
	return fetch('/api/CustomizeCertificate/EditComCustomizeCertificate', data, 'POST')
}
export const AddComCustomizeCertificate = (data) => {
	return fetch('/api/CustomizeCertificate/AddComCustomizeCertificate', data, 'POST')
}

//注册类人员
export const GetRegisterClassList = (data) => {
	return fetch('/api/RegisterClass/GetNewRegisterClassList', data, 'POST')
}
export const DeleteRegisterClass = (data) => {
	return fetch('/api/RegisterClass/DeleteRegisterClass', data, 'POST')
}
export const EditRegisterClass = (data) => {
	return fetch('/api/RegisterClass/EditRegisterClass', data, 'POST')
}
export const AddRegisterClass = (data) => {
	return fetch('/api/RegisterClass/AddRegisterClass', data, 'POST')
}

//技术职称人员
export const GetTechnicalTitleList = (data) => {
	return fetch('/api/TechnicalTitle/NewGetTechnicalTitleList', data, 'POST')
}
export const DeleteTechnicalTitle = (data) => {
	return fetch('/api/TechnicalTitle/DeleteTechnicalTitle', data, 'POST')
}
export const EditTechnicalTitle = (data) => {
	return fetch('/api/TechnicalTitle/EditTechnicalTitle', data, 'POST')
}
export const AddTechnicalTitle = (data) => {
	return fetch('/api/TechnicalTitle/AddTechnicalTitle', data, 'POST')
}
//现场管理人员
export const GetSiteManageList = (data) => {
	return fetch('/api/SiteManage/NewGetSiteManageList', data, 'POST')
}
export const DeleteSiteManage = (data) => {
	return fetch('/api/SiteManage/DeleteSiteManage', data, 'POST')
}
export const EditSiteManage = (data) => {
	return fetch('/api/SiteManage/EditSiteManage', data, 'POST')
}
export const AddSiteManage = (data) => {
	return fetch('/api/SiteManage/AddSiteManage', data, 'POST')
}
//技术工人
export const GetTechnologyWorkerList = (data) => {
	return fetch('/api/TechnologyWorker/GetNewTechnologyWorkerList', data, 'POST')
}
export const DeleteTechnologyWorker = (data) => {
	return fetch('/api/TechnologyWorker/DeleteTechnologyWorker', data, 'POST')
}
export const EditTechnologyWorker = (data) => {
	return fetch('/api/TechnologyWorker/EditTechnologyWorker', data, 'POST')
}
export const AddTechnologyWorker = (data) => {
	return fetch('/api/TechnologyWorker/AddTechnologyWorker', data, 'POST')
}
//安全三类人员
export const GetSafetyThreeTypeList = (data) => {
	return fetch('/api/SafetyThreeType/GetNewSafetyThreeTypeList', data, 'POST')
}
export const DeleteSafetyThreeType = (data) => {
	return fetch('/api/SafetyThreeType/DeleteSafetyThreeType', data, 'POST')
}
export const EditSafetyThreeType = (data) => {
	return fetch('/api/SafetyThreeType/EditSafetyThreeType', data, 'POST')
}
export const AddSafetyThreeType = (data) => {
	return fetch('/api/SafetyThreeType/AddSafetyThreeType', data, 'POST')
}
//特种作业人员
export const GetSpecialtyOperationList = (data) => {
	return fetch('/api/SpecialtyOperation/GetNewSpecialtyOperationList', data, 'POST')
}
export const DeleteSpecialtyOperation = (data) => {
	return fetch('/api/SpecialtyOperation/DeleteSpecialtyOperation', data, 'POST')
}
export const EditSpecialtyOperation = (data) => {
	return fetch('/api/SpecialtyOperation/EditSpecialtyOperation', data, 'POST')
}
export const AddSpecialtyOperation = (data) => {
	return fetch('/api/SpecialtyOperation/AddSpecialtyOperation', data, 'POST')
}
//自定义人员证书
export const GetPersonCustomizeCertificateList = (data) => {
	return fetch('/api/CustomizeCertificate/GetNewPersonCustomizeCertificateList', data, 'POST')
}
export const DeletePersonCustomizeCertificate = (data) => {
	return fetch('/api/CustomizeCertificate/DeletePersonCustomizeCertificate', data, 'POST')
}
export const EditPersonCustomizeCertificate = (data) => {
	return fetch('/api/CustomizeCertificate/EditPersonCustomizeCertificate', data, 'POST')
}
export const AddPersonCustomizeCertificate = (data) => {
	return fetch('/api/CustomizeCertificate/AddPersonCustomizeCertificate', data, 'POST')
}


// 数字证书
export const EditDigitalCertificateInfo = (data) => {
	return fetch('/api/DigitalCertificate/EditDigitalCertificateInfo?type=' + 1337, data, 'POST')
}
export const AddDigitalCertificateInfo = (data) => {
	return fetch('/api/DigitalCertificate/AddDigitalCertificateInfo?type=' + 1337, data, 'POST')
}
//企业锁
export const companyLockList = (data) => {
	return fetch('/api/DigitalCertificate/GetDigitalList?type=' + 1337, data, 'POST')
}
//网银锁
export const onlineLockList = (data) => {
	return fetch('/api/DigitalCertificate/GetDigitalList?type=' + 1338, data, 'POST')
}
//个人锁
export const personLockList = (data) => {
	return fetch('/api/DigitalCertificate/GetDigitalList?type=' + 1336, data, 'POST')
}
export const DelectDigitalCertificate = (data) => {
	return fetch('/api/DigitalCertificate/DelectDigitalCertificate', data, 'POST')
}

//在职员工
export const GetPersonnelBasicList = (data) => {
	return fetch('/api/EmployeeBasic/GetPersonnelBasicList', data, 'POST')
}
export const DeletePersonnelBasic = (data) => {
	return fetch('/api/EmployeeBasic/DeletePersonnelBasic', data, 'POST')
}

//离职员工
export const GetDeparturePersonnelBasicList = (data) => {
	return fetch('/api/EmployeeBasic/GetDeparturePersonnelBasicList', data, 'POST')
}

// 投标项目列表
export const GetProjectTenderList = (data) => {
	return fetch('/api/ProjectTender/GetProjectTenderList', data, 'POST')
}

// 中标项目列表
export const GetProjectBidTenderList = (data) => {
	return fetch('/api/ProjectTender/GetProjectBidTenderList', data, 'POST')
}

export const DeleteProjectTender = (data) => {
	return fetch('/api/ProjectTender/DeleteProjectTender', data, 'POST')
}

// 在建项目
export const GetProjectListing = (data) => {
	return fetch('/api/ProjectMainInfo/GetProjectList?type=1264', data, 'POST')
}

// 竣工项目
export const GetProjectListed = (data) => {
	return fetch('/api/ProjectMainInfo/GetProjectList?type=1265', data, 'POST')
}
export const DelectProjectInfo = (data) => {
	return fetch('/api/ProjectMainInfo/DelectProjectInfo', data, 'POST')
}

// 收款合同
export const GetProjectContractListget = (data) => {
	return fetch('/api/ProjectContract/GetProjectContractList', data, 'POST')
}
// 付款合同
export const GetProjectContractListpay = (data) => {
	return fetch('/api/ProjectContract/GetProjectContractList', data, 'POST')
}
export const DeleteProjectContract = (data) => {
	return fetch('/api/ProjectContract/DeleteProjectContract', data, 'POST')
}

//员工信息list树形结构,部门
export const NewGetDepartmentTree = (data) => {
	return fetch('/api/Department/NewGetDepartmentTree', data, 'POST')
}
//获取子部门的数据
export const GetDepartmentSubInfo = (data) => {
	return fetch('/api/Department/GetDepartmentSubInfo', data, 'POST')
}

//根据下拉框进行类型切换
export const GetCertificateClassifyList = (data) => {
	return fetch('/api/CertificateClassify/GetCertificateClassifyList', data, 'POST')
}
//根据menu_id请求权限和分公司
export const GetCurrentUserAuthority = (data) => {
	return fetch('/api/UseCase/GetCurrentUserAuthority', data, 'POST')
}
//根据基础数据请求下拉数据
export const NewGetByKey = (data) => {
	return fetch('/api/BaseData/NewGetByKey', data, 'POST')
}
//根据基础id数据请求下拉数据
export const GetById = (data) => {
	return fetch('/api/BaseData/GetById', data, 'GET')
}

//员工通讯录列表
export const GetPersonnelPhone = (data) => {
	return fetch('/api/EmployeeBasic/GetPersonnelPhone', data, 'POST')
}
//员工通讯录列表
export const GetPersonnelInfo = (data) => {
	return fetch('/api/EmployeeBasic/GetPersonnelInfo', data, 'POST')
}
//修改员工通讯录
export const EditPersonnelPhone = (data) => {
	return fetch('/api/EmployeeBasic/EditPersonnelPhone', data, 'POST')
}

//证书文件柜获取
export const GetFileFolderDetail = (data) => {
	return fetch('/api/CertificateFileCabinet/GetFileFolderDetail', data, 'POST')
}

//证书文件柜文件夹获取
export const GetCabinetFileDetail = (data) => {
	return fetch('/api/CertificateFileCabinet/GetCabinetFileDetail', data, 'POST')
}

//获取文件夹下详细的证书信息
export const GetCertificateDetialInfo = (data) => {
	return fetch('/api/CertificateFileCabinet/GetCertificateDetialWhere', data, 'POST')
}
//获取文件夹下证书信息
export const GetCertificateFileDetialInfo = (data) => {
	return fetch('/api/CertificateFileCabinet/GetCertificateFileDetialInfo', data, 'POST')
}
//获取文件夹下证书信息2
export const GetCertificateDetialAuthority = (data) => {
	return fetch('/api/CertificateFileCabinet/GetCertificateDetialAuthority', data, 'POST')
}
//添加证书文件柜信息
export const AddCertificateFileCabinet = (data) => {
	return fetch('/api/CertificateFileCabinet/AddCertificateFileCabinet', data, 'POST')
}
//删除证书文件柜信息
export const DeleteCertificateFileCabinet = (data) => {
	return fetch('/api/CertificateFileCabinet/DeleteCertificateFileCabinet', data, 'POST')
}
//编辑证书文件柜信息,包含文件夹
export const EditCertificateFileCabinet = (data) => {
	return fetch('/api/CertificateFileCabinet/EditCertificateFileCabinet', data, 'POST')
}

//文件柜下文件夹统计信息
export const GetFolderFileStatisticsInfo = (data) => {
	return fetch('/api/CertificateFileCabinet/GetFolderFileStatisticsInfo', data, 'POST')
}
//文件柜下文件移动操作
export const MoveCertificatePosition = (data) => {
	return fetch('/api/CertificateFileCabinet/MoveCertificatePosition', data, 'POST')
}

//获取考试记录列表
export const GetExamBasicList = (data) => {
	return fetch('/api/ExamBasic/GetExamBasicList', data, 'POST')
}
//获取考试记录详情数据
export const GetExamBasicDetail = (data) => {
	return fetch('/api/ExamBasic/GetExamBasicDetail', data, 'POST')
}
//新增考试记录
export const AddExamBasicInfo = (data) => {
	return fetch('/api/ExamBasic/AddExamBasicInfo', data, 'POST')
}
//修改考试记录数据
export const EditExamBasic = (data) => {
	return fetch('/api/ExamBasic/EditExamBasic', data, 'POST')
}
//删除考试管理信息
export const DelectExamBasic = (data) => {
	return fetch('/api/ExamBasic/DelectExamBasic', data, 'POST')
}

//得到选择员工基本信息列表数据
export const GetSelectPersonnelBasicList = (data) => {
	return fetch('/api/EmployeeBasic/GetSelectPersonnelBasicList', data, 'POST')
} 



/**
 * ---------   李爽    ----------
 */
//删除文件夹证书
export const DeleteCertificateSite = (data) => {
	return fetch('/api/CertificateFileCabinet/DeleteCertificateSite', data, 'POST')
}
//员工详情
export const GetPersonCertificates = (data) => {
	return fetch('/api/EmployeeBasic/GetPersonCertificates', data, 'POST')
}
export const GetPersonnelBasicDetail = (data) => {
	return fetch('/api/EmployeeBasic/GetPersonnelBasicDetail', data, 'POST')
}
export const GetUserCertificateRecordInfo = (data) => {
	return fetch('/api/EmployeeBasic/GetUserCertificateRecordInfo', data, 'POST')
}
//获取员工借证记录分页
export const UserCertificateRecordPage = (data) => {
	return fetch('/api/EmployeeBasic/UserCertificateRecordPage', data, 'POST')
}

//获取员工证书记录分页
export const UserPersonCertificatePage = (data) => {
	return fetch('/api/EmployeeBasic/UserPersonCertificatePage', data, 'POST')
}


//企业证书信息 
export const GetBusinessLicenseDetail = (data) => {
	return fetch('/api/BusinessLicense/GetBusinessLicenseDetail', data, 'POST')
}
//资质证书
export const GetQualificationsCertificateInfo = (data) => {
	return fetch('/api/QualificationsCertificate/GetQualificationsCertificateInfo', data, 'POST')
}
//安全生产许可证
export const GetSafetyLicenseInfo = (data) => {
	return fetch('/api/SafetyProductionLicense/GetSafetyLicenseInfo', data, 'POST')
}
//银行账户
export const GetBankAccountInfo = (data) => {
	return fetch('/api/BankAccount/GetBankAccountInfo', data, 'POST')
}
//自定义企业证书
export const GetComCustomizeCertificateDetail = (data) => {
	return fetch('/api/CustomizeCertificate/GetComCustomizeCertificateDetail', data, 'POST')
}
//企业锁 个人锁 网银锁
export const GetDigitalCertificateInfo = (data) => {
	return fetch('/api/DigitalCertificate/GetDigitalCertificateInfo', data, 'POST')
}
//注册类人员证书
export const GetRegisterClassDetail = (data) => {
	return fetch('/api/RegisterClass/GetRegisterClassDetail', data, 'POST')
}
//技术职称人员
export const GetTechnicalTitleDetail = (data) => {
	return fetch('/api/TechnicalTitle/GetTechnicalTitleDetail', data, 'POST')
}
//现场管理人员
export const GetSiteManageDetail = (data) => {
	return fetch('/api/SiteManage/GetSiteManageDetail', data, 'POST')
}
//技术人员
export const GetTechnologyWorkerDetail = (data) => {
	return fetch('/api/TechnologyWorker/GetTechnologyWorkerDetail', data, 'POST')
}
//安全三类人员
export const GetSafetyThreeTypeDetail = (data) => {
	return fetch('/api/SafetyThreeType/GetSafetyThreeTypeDetail', data, 'POST')
}
//特种作业人员
export const GetSpecialtyOperationDetail = (data) => {
	return fetch('/api/SpecialtyOperation/GetSpecialtyOperationDetail', data, 'POST')
}
//自定义人员
export const GetPersonCustomizeCertificateDetail = (data) => {
	return fetch('/api/CustomizeCertificate/GetPersonCustomizeCertificateDetail', data, 'POST')
}
//投标项目信息 中标项目信息
// export const GetProjectTenderDetail = (data) => {
// 	return fetch('/api/ProjectTender/GetProjectTenderDetail', data, 'POST')
// }
//在建项目 竣工项目
export const GetProjectInfo = (data) => {
	return fetch('/api/ProjectMainInfo/GetProjectInfo', data, 'POST')
}
//收款合同 付款合同
export const GetProjectContractDetail = (data) => {
	return fetch('/api/ProjectContract/GetProjectContractDetail', data, 'POST')
}
//地址
export const GetAddress = (data) => {
	return fetch('/api/Address/GetAddress', data, 'GET')
}
//添加员工信息
export const AddEmployeeBasic = (data) => {
	return fetch('/api/EmployeeBasic/AddEmployeeBasic', data, 'POST')
}
//编辑员工信息
export const EditPersonnelBasic = (data) => {
	return fetch('/api/EmployeeBasic/EditPersonnelBasic', data, 'POST')
}
//添加劳动合同
export const AddEmployeeContract = (data) => {
	return fetch('/api/EmployeeContract/AddEmployeeContract', data, 'POST')
}
//删除劳动合同
export const DeleteEmployeeContract = (data) => {
	return fetch('/api/EmployeeContract/DeleteEmployeeContract', data, 'POST')
}
//添加社保信息
export const AddEmployeeSocialInsurance = (data) => {
	return fetch('/api/EmployeeSocialInsurance/AddEmployeeSocialInsurance', data, 'POST')
}
//删除社保信息
export const DeleteEmployeeSocialInsurance = (data) => {
	return fetch('/api/EmployeeSocialInsurance/DeleteEmployeeSocialInsurance', data, 'POST')
}
//添加公积金
export const AddEmployeeProvidentFund = (data) => {
	return fetch('/api/EmployeeProvidentFund/AddEmployeeProvidentFund', data, 'POST')
}
//删除公积金
export const DeleteEmployeeProvidentFund = (data) => {
	return fetch('/api/EmployeeProvidentFund/DeleteEmployeeProvidentFund', data, 'POST')
}
//修改劳动合同
export const EditEmployeeContract = (data) => {
	return fetch('/api/EmployeeContract/EditEmployeeContract', data, 'POST')
}

//修改社保信息
export const EditEmployeeSocialInsurance = (data) => {
	return fetch('/api/EmployeeSocialInsurance/EditEmployeeSocialInsurance', data, 'POST')
}
//修改公积金
export const EditEmployeeProvidentFund = (data) => {
	return fetch('/api/EmployeeProvidentFund/EditEmployeeProvidentFund', data, 'POST')
}
//文件柜地址获取 
export const GetCertificateFileCabinetList = (data) => {
	return fetch('/api/CertificateFileCabinet/GetCertificateFileCabinetListNew', data, 'GET')
}

//预警列表
export const GetSystemWareConfigurationList = (data) => {
	return fetch('/api/SystemWareConfiguration/GetSystemWareConfigurationList', data, 'POST')
}
//员工身份证验证
export const VerificationRepeatData = (data) => {
	return fetch('/api/PublicVerification/VerificationRepeatData', data, 'POST')
}





//预警启用关闭
export const EditSystemWareConfiguration = (data) => {
	return fetch('/api/SystemWareConfiguration/EditSystemWareConfiguration', data, 'POST')
}
//预警获取人员
export const GetSelectRole = (data) => {
	return fetch('/api/SystemWareConfiguration/GetSelectRole', data, 'POST')
}
//敏感词
export const GetSensitiveWordList = (data) => {
	return fetch('/api/SensitiveWord/GetSensitiveWordList', data, 'POST')
}
//敏感词开启
export const OpenOrCloseSensitiveWord = (data) => {
	return fetch('/api/SensitiveWord/OpenOrCloseSensitiveWord', data, 'POST')
}
//基础设置
export const GetClassify = (data) => {
	return fetch('/api/BaseData/GetClassify', data, 'POST')
}
//项目经理
export const GetProjectManagerList = (data) => {
	return fetch('/api/ProjectUserMakeUp/GetProjectManagerList', data, 'POST')
}
//班组成员
export const GetProjectUserList = (data) => {
	return fetch('/api/ProjectUserMakeUp/GetProjectUserList', data, 'POST')
}
// 合同项目名称
export const GetSelectProjectInfo = (data) => {
	return fetch('/api/ProjectContract/GetSelectProjectInfo', data, 'POST')
}





/*---------   粟雪梅    ----------*/
// 获取投标信息
export const GetProjectTenderDetail = (data) => {
	return fetch('/api/ProjectTender/GetProjectTenderDetail', data, 'POST')
}
// 编辑投标
export const EditProjectTender = (data) => {
	return fetch('/api/ProjectTender/EditProjectTender', data, 'POST')
}

// 保证金往来
export const AddProjectTenderMargin = (data) => {
	return fetch('/api/ProjectTenderMargin/AddProjectTenderMargin', data, 'POST')
}
export const DeleteProjectTenderMargin = (data) => {
	return fetch('/api/ProjectTenderMargin/DeleteProjectTenderMargin', data, 'POST')
}

// 项目执行记录
export const AddProjectTenderCarry = (data) => {
	return fetch('/api/ProjectTenderCarry/AddProjectTenderCarry', data, 'POST')
}
export const DeleteProjectTenderCarry = (data) => {
	return fetch('/api/ProjectTenderCarry/DeleteProjectTenderCarry', data, 'POST')
}


// 新增投标
export const AddProjectTender = (data) => {
	return fetch('/api/ProjectTender/AddProjectTender', data, 'POST')
}

// 新增中标
export const AddProjectTenderAuditRecord = (data) => {
	return fetch('/api/ProjectTender/AddProjectTenderAuditRecord', data, 'POST')
}

// 新增项目
export const AddProjectMainInfo = (data) => {
	return fetch('/api/ProjectMainInfo/AddProjectMainInfo', data, 'POST')
}
export const EditProjectMainInfo = (data) => {
	return fetch('/api/ProjectMainInfo/EditProjectMainInfo', data, 'POST')
}
// 班组成员
export const AddProjectUser = (data) => {
	return fetch('/api/ProjectMainInfo/AddProjectUser', data, 'POST')
}
export const DelectProjectUserMake = (data) => {
	return fetch('/api/ProjectMainInfo/DelectProjectUserMake', data, 'POST')
}
// 单位信息
export const AddProjectCompany = (data) => {
	return fetch('/api/ProjectMainInfo/AddProjectCompany', data, 'POST')
}
export const DelectProjectCompany = (data) => {
	return fetch('/api/ProjectMainInfo/DelectProjectCompany', data, 'POST')
}

// 新增合同
export const AddProjectContract = (data) => {
	return fetch('/api/ProjectContract/AddProjectContract', data, 'POST')
}
export const EditProjectContract = (data) => {
	return fetch('/api/ProjectContract/EditProjectContract', data, 'POST')
}



/*---------   黄英    ----------*/
//证书借还
export const GetCertificateRecordList = (data) => {
	return fetch('/api/CertificateBorrowOrRecord/GetCertificateRecordList', data, 'POST')
}
// 证书借出
export const GetCertificateBorrowInfo = (data) => {
	return fetch('/api/CertificateBorrowOrRecord/GetCertificateBorrowInfo', data, 'POST')
}
//借证
export const GetCurrentUserCertificateRecordList = (data) => {
	return fetch('/api/CertificateBorrowOrRecord/GetCurrentUserCertificateRecordList', data, 'POST')
}
//归还
export const EditCertificate = (data) => {
	return fetch('/api/CertificateBorrowOrRecord/EditCertificate', data, 'POST')
}
//意见反馈
export const AddFeedback = (data) => {
	return fetch('/api/Feedback/AddFeedback', data, 'POST')
}

/*---------  曲一鸣    ----------*/

//员工统计获取
export const GetAllPersonnelMessage=(data)=>{
	return fetch('/api/EmployeeBasic/EmployeeJobStatistics',data,'POST')
}
//员工地址获取
export const GetEmployeeAddress=(data)=>{
	return fetch('/api/EmployeeBasic/GetPersonAddressStatistics',data,'GET')
}
//证书名称请求
export const GetCertificateName=(data)=>{
	return fetch('/api/BaseData/NewGetByKey',data,'POST')
}
//增项证书请求
export const GetCertificateMajor=(data)=>{
	return fetch('/api/BaseData/GetById',data,'GET')
}
//增项人员请求
export const GetListData=(data)=>{
	return fetch('/api/CertificateStatistics/AddItemStatistics',data,'POST')
}
//B证统计
export const GetBCertificate=(data)=>{
	return fetch('/api/CertificateStatistics/BCertificateStatistics',data,'POST')
}
//证书统计表格，所有人员
export const GetCertificateStatistics=(data)=>{
	return fetch('/api/CertificateStatistics/AllCertificateStatistics',data,'POST')
}
//证书统计联动下拉首选项
export const GetFirstSelect=(data)=>{
	return fetch('/api/CertificateClassify/GetCertificateClassifyList',data,'POST')
}
//证书统计联动下拉框数据
export const GetCertificateSelect=(data)=>{
	return fetch('/api/CertificateStatistics/CertificateSelect',data,'POST')
}

//办事指南的数据
export const nav_url = (data) => {
	return fetch({
		url:'//api.58jzr.com/api/NavUrl/GetNavUrlList'
	}, data, 'GET')
}


// WEBPACK FOOTER //
// ./src/js/urls.js